export default "__VITE_PUBLIC_ASSET__3ce94fb6__"